import StateNotice from './StateNotice.jsx';

export default StateNotice;